// extracted by mini-css-extract-plugin
export default {"footer_english":"tree-printing_footer_english__wsVnI","footer_Hebrew":"tree-printing_footer_Hebrew__w3MJu"};